import * as React from 'react'
import * as constants from 'static/constants'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'

const CountryFlagSelect: React.VFC<{
  name: string
  countries: any[]
  defaultValue: string
  required?: boolean
  placeholder?: string
  onChangeHandler: (code: string) => void
}> = ({ name, countries, defaultValue, required, placeholder, onChangeHandler }) => {
  const selectRef = React.useRef(null)
  const [countryCode, setCountryCode] = React.useState(defaultValue)
  React.useEffect(() => {
    onChangeHandler(countryCode)
  }, [countryCode])

  const onClickParent = () => {
    if (selectRef.current) {
      selectRef.current.focus()
      selectRef.current.showPicker()
    }
  }

  return (
    <CountryFlagSelectWrapper onClick={onClickParent}>
      {countryCode && (
        <img
          src={`https://flagcdn.com/${countryCode.toLowerCase()}.svg`}
          width="24"
          height="18"
          alt={countryCode}
          onError={e => {
            ;(e.currentTarget as HTMLImageElement).style.display = 'none'
          }}
        />
      )}
      {placeholder && !countryCode && <span>{placeholder}</span>}
      <select
        ref={selectRef}
        required={required}
        name={name}
        defaultValue={countryCode}
        onChange={e => setCountryCode(e.target.value)}
      >
        {countries.map(country => (
          <option key={country.code} value={country.code}>
            {country.name_en}
          </option>
        ))}
      </select>
      <SvgIcon
        name="keyboard_arrow_down"
        className="down_icon"
        ariaHidden={true}
        role="presentation"
      />
    </CountryFlagSelectWrapper>
  )
}
const CountryFlagSelectWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 24px;
  border: solid 1px ${constants.COLORS.divider};
  border-radius: 12px;
  cursor: pointer;
  z-index: 999;
  transition: border-color 0.2s;
  &:hover,
  &:focus-within {
    border-color: ${constants.COLORS.primary};
  }
  > .down_icon {
    flex: none;
    width: 24px;
    height: 24px;
  }
  > span {
    cursor: pointer;
    position: absolute;
    pointer-events: none;
    color: ${constants.COLORS.subText};
  }
  > select {
    cursor: pointer;
    appearance: none;
    margin: 0;
    padding: 0;
    background: none transparent;
    vertical-align: middle;
    font-size: inherit;
    color: inherit;
    outline: none;
    border: none;
    width: 100%;
    line-height: 18px;
    margin-left: 8px;
  }
`

export default CountryFlagSelect
